import React from 'react';

import CurrencySign from 'components/price/CurrencySign.component';

class ItemUnlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unlockCalled: false,
    };
  }
  unlockDeposit = () => {
    if (!this.props.unlocked && !this.state.unlockCalled) {
      this.props.unlockDeposit(this.props.salonId, this.props.id);
      this.setState({ unlockCalled: true });
    }
  };
  render() {
    return (
      <>
        <li key={this.props.index} className="flex-3-colmn">
          <div className="appointment-date">{this.props.date}</div>
          <div className="booked-services">
            <CurrencySign />
            {this.props.amount}
          </div>
          <div className="amount-deposited">
            <button onClick={this.unlockDeposit} className={`btn btn-violet ${this.props.styles}`}>
              {this.props.buttonText}
            </button>
          </div>
        </li>
      </>
    );
  }
}

export default ItemUnlock;
